import { Badge } from "@/shared/ui/badge";
import { useTranslation } from "@/shared/i18n";
import { isCreatorFinancialMock } from "../config";

/** Exibe um aviso quando as telas estão em modo mock (dados ainda não prontos). */
export function MockBanner() {
  const { t } = useTranslation("creator-financial");
  if (!isCreatorFinancialMock) return null;
  return (
    <Badge
      variant="outline"
      className="mb-4 border-amber-500/50 bg-amber-500/10 text-amber-600 dark:text-amber-400"
    >
      {t("mockBanner")}
    </Badge>
  );
}
